import React from 'react';

import {SanityPullQuoteImage} from 'types/generated';

export const PullQuoteImage: React.FC<SanityPullQuoteImage> = props => {
  return (
    <section
      className="w-full md:w-1/2 md:mr-8 md:float-left pb-8 py-8 md:py-0 relative mb-4"
      data-module="image-w-quote"
    >
      <div className="w-full relative z-20">
        <figure>
          <img className="w-full h-full" src={props.pullQuoteImage?.asset?.url || ''} alt="" />
          <figcaption className="type-xs-p mt-2">{props.pullQuoteImage?.caption}</figcaption>
        </figure>

        {props.quote && (
          <div className="mt-7 border-l-4 border-dark-gold md:py-1">
            <div className="type-theta text-dark-gold ml-8 lg:ml-10 relative">
              <p
                className="before:content-['“'] before:absolute before:-left-[0.60rem] 
                lg:before:-left-4 before:type-theta lg:before:text-[25px] 
                after:content-['”'] after:absolute after:type-theta lg:after:text-[25px]"
              >
                {props.quote}
              </p>
            </div>
            {!!props.quoteSource && (
              <span className="block type-sm-p mt-3 ml-8 md:ml-10 text-gray ">{props.quoteSource}</span>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
